import {
  apiGet as get,
  apiPostMultipart as postMultipart,
  apiPost as post,
  apiPut as put,
  apiDelete,
} from 'helpers/ApiHelper';
import { showFailure, showSuccess } from 'actions/notificationActions';
import Auth from 'j-toker';
import {
  OPEN_RENEWAL_WIZARD,
  CLOSE_RENEWAL_WIZARD,
  FETCH_PROPOSALS,
  STORE_PROPOSALS,
  SELECT_PROPOSAL,
  SELECT_LEASE_TERM,
  FETCH_YARDI_LEASE,
  STORE_DETAILS,
  CLEAR_DETAILS,
  FETCH_SCHEDULE_AS,
  STORE_SCHEDULE_AS,
  CREATE_SCHEDULE_AS,
  FETCH_LEASE_COTENANTS,
  STORE_LEASE_COTENANTS,
  CREATE_RENEWAL,
  STORE_SELECTED_APPLICANTS,
  STORE_DEFAULT_SERVICES_AND_UTILS,
  STORE_DEFAULT_LEASE_DOCUMENT_TYPES,
  STORE_USE_NOTICE_OF_INCREASE,
  INVITE_APPLICANT,
  BYPASS_APPLICANT,
  APPROVE_APPLICANT,
  STORE_RENEWAL,
  SUBMIT_RENEWAL,
  CANCEL_RENEWAL,
} from './actionTypes';

export function openRenewalWizard(leaseId) {
  return dispatch => {
    return dispatch({ type: OPEN_RENEWAL_WIZARD, leaseId: leaseId });
  };
}

export function closeRenewalWizard() {
  return dispatch => {
    return dispatch({ type: CLOSE_RENEWAL_WIZARD });
  };
}

export function fetchYardiLease(leaseId) {
  return async dispatch => {
    dispatch({ type: FETCH_YARDI_LEASE });
    const url = `${Auth.getApiUrl()}/landlords/leases/${leaseId}/fetch_lease`;
    const res = await get(url);

    const { services_and_utilities, lease_document_types } = res;
    if (services_and_utilities) {
      dispatch({ type: STORE_DEFAULT_SERVICES_AND_UTILS, services_and_utilities });
    }

    if (lease_document_types?.length > 0) {
      dispatch({ type: STORE_DEFAULT_LEASE_DOCUMENT_TYPES, lease_document_types });
    }

    const { use_n1, use_n2 } = res;
    if (use_n1 || use_n2) {
      dispatch({ type: STORE_USE_NOTICE_OF_INCREASE, use_n1, use_n2 });
    }

    return res;
  };
}

export function fetchProposals(leaseId) {
  return async dispatch => {
    dispatch({ type: FETCH_PROPOSALS });
    const url = `${Auth.getApiUrl()}/landlords/leases/${leaseId}/renewal_offers`;
    const res = await get(url);

    dispatch({ type: STORE_PROPOSALS, proposals: res });
    return res;
  };
}

export function selectLeaseTerm(leaseTerm) {
  return dispatch => {
    dispatch({ type: SELECT_LEASE_TERM, selectedLeaseTerm: leaseTerm });
  };
}

export function selectProposal(proposalData) {
  return dispatch => {
    dispatch({ type: SELECT_PROPOSAL, selectedProposal: proposalData });
  };
}

export function storeDetails(details) {
  return dispatch => {
    dispatch({ type: STORE_DETAILS, details: details });
    return details;
  };
}

export function clearDetails() {
  return dispatch => {
    return dispatch({ type: CLEAR_DETAILS });
  };
}

export function fetchScheduleAs() {
  return async dispatch => {
    dispatch({ type: FETCH_SCHEDULE_AS });
    let scheduleAs;
    const url = `${Auth.getApiUrl()}/landlords/schedule_as`;
    const res = await get(url);
    // Checking if there is a data field on the response because if no scheduleAs present we return a object with data key not an array
    if (res.data) {
      scheduleAs = res.data;
    } else {
      scheduleAs = res;
    }
    dispatch({ type: STORE_SCHEDULE_AS, scheduleAs: scheduleAs });
    return res;
  };
}

export function createScheduleA(name, document) {
  let formData = new FormData();
  formData.append('name', name);
  formData.append('document', document);

  return async dispatch => {
    dispatch({ type: CREATE_SCHEDULE_AS });
    const url = `${Auth.getApiUrl()}/landlords/schedule_as`;

    try {
      const res = await postMultipart(url, formData);
      dispatch(showSuccess('landlordPortal.rentRoll.renewals.addedSuccessfully'));
      return res;
    } catch (err) {
      dispatch(showFailure('landlordPortal.rentRoll.renewals.failedToAdd'));
      return;
    }
  };
}

export function fetchLeaseCotenants(leaseId) {
  return async dispatch => {
    dispatch({ type: FETCH_LEASE_COTENANTS });
    const url = `${Auth.getApiUrl()}/landlords/leases/${leaseId}/cotenants`;
    const res = await get(url);
    dispatch({ type: STORE_LEASE_COTENANTS, leaseCotenants: res });
    return res;
  };
}

export function createRenewal(data) {
  let formData = {
    lease_id: data.leaseId,
    selected_term_id: data.selectedProposal.term_id,
    term_length: data.selectedLeaseTerm,
    rent: data.selectedProposal.rent,
    lease_from_date: data.selectedProposal.lease_from_date,
    lease_to_date: data.selectedProposal.lease_to_date,
    services_and_utilities: {
      services: data.details.services,
      utilities: data.details.utilities,
    },
    lease_charges: data.selectedProposal.charges,
    renters_insurance_required: data.details.insurance_required,
    schedule_a_id: data.details.schedule_a_id,
    notice_of_increase: data.details.notice_of_increase,
    lease_documents: data.details.lease_documents,
  };

  return async dispatch => {
    dispatch({ type: CREATE_RENEWAL });
    const url = `${Auth.getApiUrl()}/landlords/renewals`;
    const res = await post(url, formData);
    dispatch({ type: STORE_RENEWAL, renewal: res });
    return res;
  };
}

export function storeSelectedApplicants(selectedApplicants) {
  return dispatch => {
    dispatch({
      type: STORE_SELECTED_APPLICANTS,
      selectedApplicants: selectedApplicants,
    });
  };
}

export function approveApplicant(cotenantId) {
  return async dispatch => {
    dispatch({ type: APPROVE_APPLICANT });
    const url = `${Auth.getApiUrl()}/landlords/tenants/${cotenantId}/approve_application`;
    return await put(url);
  };
}

export function bypassApplicant(cotenantId) {
  return async dispatch => {
    dispatch({ type: BYPASS_APPLICANT });
    const url = `${Auth.getApiUrl()}/landlords/tenants/${cotenantId}/bypass_application`;
    return await put(url);
  };
}

export function inviteApplicant(cotenantId) {
  return async dispatch => {
    dispatch({ type: INVITE_APPLICANT });
    const url = `${Auth.getApiUrl()}/landlords/tenants/${cotenantId}/invite_to_apply`;
    const res = await put(url);
    return res;
  };
}

export function submitRenewal(renewalId) {
  return async dispatch => {
    dispatch({ type: SUBMIT_RENEWAL });
    const url = `${Auth.getApiUrl()}/landlords/renewals/${renewalId}/submit`;
    const res = await post(url);
    return res;
  };
}

export function cancelRenewal(renewalId) {
  return async dispatch => {
    dispatch({ type: CANCEL_RENEWAL });
    const url = `${Auth.getApiUrl()}/landlords/renewals/${renewalId}`;
    try {
      await apiDelete(url);
      dispatch(showSuccess('landlordPOrtal.rentRoll.renewals.deleteSuccessfully'));
    } catch (err) {
      dispatch(showFailure('landlordPOrtal.rentRoll.renewals.deleteFailed'));
      throw err;
    }
  };
}

export function reassignAgentRenewal(renewalID, reassignedAgent) {
  return dispatch => {
    return dispatch({
      payload: put(
        Auth.getApiUrl() + `/landlords/renewals/${renewalID}/reassign_agent`,
        reassignedAgent
      )
        .done(() => {
          dispatch(showSuccess('landlordPortal.renewal.assignedAgentSuccessfullyUpdated'));
        })
        .catch((error, textStatus) => {
          dispatch(showFailure(error));
          console.error(textStatus);
        }),
    });
  };
}
